type FeatureFlagDefinition = {
  envKey: string;
  defaultEnabled: boolean;
};

const FEATURE_FLAGS = {
  gmoPaymentEnabled: {
    envKey: "VITE_FEATURE_FLAG_GMO_PAYMENT_ENABLED",
    defaultEnabled: false,
  },
  reservationDeadlinePastOnly: {
    envKey: "VITE_FEATURE_FLAG_RESERVATION_DEADLINE_PAST_ONLY",
    defaultEnabled: false,
  },
  // 患者のログインを Cognito から SAS 自身の画面へ切り替える（Issue #473）。API 側のフラグと同時に ON にする
  patientSelfAuthEnabled: {
    envKey: "VITE_FEATURE_FLAG_PATIENT_SELF_AUTH_ENABLED",
    defaultEnabled: false,
  },
} as const satisfies Record<string, FeatureFlagDefinition>;

const parseBoolean = (
  value: string | undefined,
  defaultValue: boolean,
): boolean => {
  if (value == null) return defaultValue;
  const normalized = value.trim().toLowerCase();
  if (
    normalized === "true" ||
    normalized === "1" ||
    normalized === "yes" ||
    normalized === "on"
  ) {
    return true;
  }
  if (
    normalized === "false" ||
    normalized === "0" ||
    normalized === "no" ||
    normalized === "off"
  ) {
    return false;
  }
  return defaultValue;
};

const readEnv = (key: string): string | undefined => {
  const value = import.meta.env[key as keyof ImportMetaEnv];
  return typeof value === "string" ? value : undefined;
};

const isEnabled = (definition: FeatureFlagDefinition): boolean =>
  parseBoolean(readEnv(definition.envKey), definition.defaultEnabled);

export const isGmoPaymentEnabled = (): boolean =>
  isEnabled(FEATURE_FLAGS.gmoPaymentEnabled);

export const isReservationDeadlinePastOnlyEnabled = (): boolean =>
  isEnabled(FEATURE_FLAGS.reservationDeadlinePastOnly);

export const shouldApplySameOrNextDayCutoffRule = (): boolean =>
  !isReservationDeadlinePastOnlyEnabled();

export const isPatientSelfAuthEnabled = (): boolean =>
  isEnabled(FEATURE_FLAGS.patientSelfAuthEnabled);
